import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatDate } from 'shared/dates';
import { AlertStatus, formatDay } from './AlertDetails.utils';

type DateStatValueProps = {
  date: Date | null;
  status: AlertStatus;
};

export const DateStatValue = (props: DateStatValueProps): JSX.Element => {
  const { date, status } = props;
  const { t } = useTranslation();

  if (!date) {
    return <>-</>;
  }

  if (status === 'expired') {
    return (
      <Stack spacing={0.75} alignItems="center" sx={{ mt: 0.5 }}>
        <Typography fontWeight="fontWeightBold">
          {formatDate(date, 'MMM d, yyyy')}
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          {formatDate(date, 'h:mm a')}
        </Typography>
      </Stack>
    );
  }

  if (status === 'active') {
    return (
      <Stack spacing={0.75} alignItems="center" sx={{ mt: 0.5 }}>
        <Typography fontWeight="fontWeightBold">
          {formatDate(date, 'h:mm a')}
        </Typography>
        <Box>
          <Typography
            variant="subtitle1"
            color="textSecondary"
            fontWeight="fontWeightBold"
          >
            {formatDay(date, t)}
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            {formatDate(date, 'MMM d')}
          </Typography>
        </Box>
      </Stack>
    );
  }

  // status === 'future'
  return (
    <Stack spacing={0.75} alignItems="center" sx={{ mt: 0.5 }}>
      <Typography fontWeight="fontWeightBold">{formatDay(date, t)}</Typography>
      <Box>
        <Typography
          variant="subtitle1"
          color="textSecondary"
          fontWeight="fontWeightBold"
        >
          {formatDate(date, 'h:mm a')}
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          {formatDate(date, 'MMM d')}
        </Typography>
      </Box>
    </Stack>
  );
};
